const KEYS = {
  ATTACHMENTS: 'attachments',
  LEADS: 'leads',
  COMPANIES: 'companies',
  ACCOUNT_USERS: 'account-users',
  NOTES: 'notes',
  NOTE_COMMENT: 'noteComments',
  LOGS: 'logs',
  LEADS_LOG: 'lead_logs',
  COMPANY_LOG: 'company_logs',
  CALLS: 'calls',
  DETAILS: 'details',
  SMS: 'sms',
  SMS_ACCOUNT_CONVERSATIONS: 'sms-account-conversations',
  SMS_ACCOUNT_CONVERSATIONS_UNREAD: 'sms-account-conversations-unread',
  SMS_ACCOUNT: 'sms-account',
  TASK: 'tasks',
  DEALS: 'contact_deals',
  EMAIL_OPTIONS: 'email-options',
  EMAIL_THREADS: 'email-threads',
  EMAIL_THREAD: 'email-threads',
  EMAIL_ATTACHMENT: 'email-attachment',
  DATA_RECORDS: 'data-record',
};

const TaskFilter = {
  accountUserId: [],
  status: 'ALL',
  type: [],
};

export default {
  ...KEYS,
  TaskFilter,
};
